import React from 'react'
import { useIntl } from 'react-intl'
import { Modal } from 'antd'
import Cancel from 'components/UI/Button/Cancel'
import { UpgradeBilling } from './HideFeature'

// BE belum kirim kode error khusus. Limit WA akun non-berbayar dikenali dari respons 422
// (format lama 400) yang pesannya menyuruh upgrade, mis. "Pengiriman WhatsApp dibatasi 2 per hari.
// Silakan upgrade ...". Pesan limit paket berbayar tidak menyebut upgrade, jadi tidak membuka modal.
// Mengembalikan pesan dari BE, atau '' kalau error bukan limit yang perlu upgrade.
export const getWhatsappLimitMessage = (error) => {
  if (![400, 422].includes(error?.status)) {
    return ''
  }

  const message = error?.data?.errors?.warning?.[0] ?? error?.data?.message ?? ''
  return /upgrade/i.test(message) ? message : ''
}

// Modal upgrade saat kirim WA kena limit harian. Isi pesan diambil dari BE.
const WhatsappLimitModal = ({ message, onClose }) => {
  const { formatMessage } = useIntl()

  return (
    <Modal
      open={!!message}
      title={formatMessage({ id: 'billing.paid_plan_features' })}
      onCancel={onClose}
      footer={[<Cancel key="cancel" onClick={onClose} />]}
    >
      <UpgradeBilling label={message} />
    </Modal>
  )
}

export default WhatsappLimitModal
